(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-hde-deadline]').forEach((section) => {
      if (section.dataset.hdeTimerReady) return;
      section.dataset.hdeTimerReady = 'true';
      const raw = section.dataset.hdeDeadline;
      // A fixed absolute deadline is shared by every shopper; never reset per visit.
      if (!/(Z|[+-]\d{2}:\d{2})$/.test(raw)) { section.hidden = true; return; }
      const deadline = Date.parse(raw);
      if (!Number.isFinite(deadline)) { section.hidden = true; return; }
      let timer;
      const update = () => {
        const remaining = Math.floor((deadline - Date.now()) / 1000);
        if (remaining <= 0 || !section.isConnected) {
          section.hidden = true;
          if (timer) clearInterval(timer);
          return false;
        }
        const values = {days:Math.floor(remaining / 86400),hours:Math.floor(remaining / 3600) % 24,minutes:Math.floor(remaining / 60) % 60,seconds:remaining % 60};
        Object.entries(values).forEach(([key,value]) => { section.querySelector(`[data-${key}]`).textContent = String(value).padStart(2,'0'); });
        section.querySelector('.hde-timed-offer__digits').hidden = false;
        return true;
      };
      if (update()) timer = setInterval(update,1000);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load',event => initialize(event.target));
})();
